'use client';

import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { accountLevelNameByApp, getAppConfig } from '@bts-web/core-app-config';
import { SVGIconType } from '../../../../common/types';
import { useClientUserInfo } from '../../../../common/userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';
import { RegularPerson } from '../../../../common/svgIcons';

export const RegularPersonWithAccountLevel: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  backgroundColor,
  ...restProps
}) => {
  const { accountLevel } = useClientUserInfo();

  const { appName } = getAppConfig();

  const userAccountLevels = accountLevelNameByApp[appName];

  const isPremiumUser = accountLevel?.name === userAccountLevels?.premium.name;

  return (
    <div
      className={css({
        backgroundColor: backgroundColor || 'neutrals.fill_quaternary',
        color: 'neutrals.fill_secondary',
        borderRadius: '100%',
        p: 'extra_small_2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid transparent',
        ...(isPremiumUser && {
          background:
            'linear-gradient(#EAEAEA, #EAEAEA) padding-box, linear-gradient(to bottom, rgba(166, 140, 110, 1), rgba(244, 222, 184, 1)) border-box',
        }),
      })}
    >
      <RegularPerson
        size={size}
        color={color}
        width={width}
        height={height}
        className={className}
        {...restProps}
      />
    </div>
  );
};
